module.exports = __webpack_public_path__ + "static/FleetManagement-2e9486b4ad9d19d699302aa11c8efd8c.svg";